import React, { useState, useEffect } from 'react';
import { Box, Typography, Zoom, Fade } from '@mui/material';
import { Stars as XpIcon, MonetizationOn as CoinsIcon } from '@mui/icons-material';

const FloatingXpReward = ({ xp = 0, coins = 0, visible, onComplete }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (visible && (xp > 0 || coins > 0)) {
            setShow(true);
            const timer = setTimeout(() => {
                setShow(false);
                setTimeout(() => onComplete?.(), 500); // Wait for fade out
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [visible, xp, coins, onComplete]);

    if (!visible || (xp === 0 && coins === 0)) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '20%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 9999,
                pointerEvents: 'none',
            }}
        >
            <Fade in={show} timeout={500}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    {xp > 0 && (
                        <Zoom in={show} timeout={300} style={{ transitionDelay: '0ms' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    px: 3,
                                    py: 1.5,
                                    borderRadius: 25,
                                    background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: '1.2rem',
                                    boxShadow: '0 8px 30px rgba(255,215,0,0.4)',
                                    animation: 'float-up 2s ease-out forwards',
                                    '@keyframes float-up': {
                                        '0%': { transform: 'translateY(0px)', opacity: 1 },
                                        '100%': { transform: 'translateY(-50px)', opacity: 0.8 }
                                    }
                                }}
                            >
                                <XpIcon sx={{ fontSize: 28 }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    +{xp} XP
                                </Typography>
                            </Box>
                        </Zoom>
                    )}

                    {coins > 0 && (
                        <Zoom in={show} timeout={300} style={{ transitionDelay: '200ms' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    px: 3,
                                    py: 1.5,
                                    borderRadius: 25,
                                    background: 'linear-gradient(135deg, #FF8C00, #FFD700)',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: '1.1rem',
                                    boxShadow: '0 8px 30px rgba(255,140,0,0.4)',
                                    animation: 'float-up 2s ease-out forwards',
                                    animationDelay: '0.2s',
                                    '@keyframes float-up': {
                                        '0%': { transform: 'translateY(0px)', opacity: 1 },
                                        '100%': { transform: 'translateY(-40px)', opacity: 0.8 }
                                    }
                                }}
                            >
                                <CoinsIcon sx={{ fontSize: 24 }} />
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    +{coins} Coins
                                </Typography>
                            </Box>
                        </Zoom>
                    )}
                </Box>
            </Fade>
        </Box>
    );
};

export { FloatingXpReward };
